<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-55">
        <md-field :md-counter="false">
          <label class="mlabel" for="chiefComplaint">Chief Complaint</label>
          <md-input
            id="chiefComplaint"
            v-model="chiefComplaint"
            maxlength="40"
            type="text"
            name="chiefComplaint"
            md-dense
          ></md-input>
        </md-field>
      </div>

      <div class="md-layout-item md-size-100 md-small-size-100">
        <div class="textarea-container">
          <textarea
            id="issues"
            v-model="issues"
            maxlength="500"
            style="width: 100%; padding: 10px 15px 10px 15px"
            name="issues"
            placeholder="Please describe issues . . ."
            resize="auto"
          ></textarea>
        </div>
      </div>

      <div class="md-layout-item md-size-100 md-small-size-100" style="margin-top: 20px">
        <h6>Ocular History</h6>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field>
          <label for="correctiveLens">Wear corrective Lenses</label>
          <md-select v-model="correctiveLens" name="correctiveLens">
            <md-option value="None">No</md-option>
            <md-option value="I wear Glasses">I wear Glasses</md-option>
            <md-option value="I wear Contacts">I wear Contacts</md-option>
            <md-option value="I wear Glasses and Contacts">I wear Glasses and Contacts</md-option>
            <md-option value="I wear a Bifocal or Progressive">I wear a Bifocal or Progressive</md-option>
            <md-option value="I wear OTC readers">I wear OTC readers</md-option>
            <md-option value="I wear SCL">I wear SCL</md-option>
            <md-option value="I wear Glasses and SCL">I wear Glasses and SCL</md-option>
          </md-select>
        </md-field>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field>
          <label for="previousEyeSurgery">Previous Eye Surgery</label>
          <md-select v-model="previousEyeSurgery" name="previousEyeSurgery">
            <md-option value="638">None</md-option>
            <md-option value="639">Glaucoma</md-option>
            <md-option value="640">Cataracts</md-option>
            <md-option value="641">Astigmatism</md-option>
            <md-option value="642">Transplant</md-option>
            <md-option value="643">Refractive</md-option>
            <md-option value="644">LASIK</md-option>
            <md-option value="645">(PRK) Photorefractive Keratectomy</md-option>
            <md-option value="646">(RK) Radial Keratectomy</md-option>
            <md-option value="647">(CK) Conductive Keratoplasty</md-option>
            <md-option value="648">Intacs</md-option>
            <md-option value="650">Retina</md-option>
            <md-option value="649">Other</md-option>
          </md-select>
        </md-field>
      </div>
    </div>

    <div class="md-layout-item md-size-100 md-small-size-100">
      <div v-if="correctiveLens && correctiveLens !== 'None'" class="field-container">
        <div class="md-layout">
          <div v-if="showGlassesFields" >
            <div class="md-layout-item md-size-100 md-small-size-100">
              <h6>Glasses Information</h6>
            </div>

            <!-- OD Data -->
            <eye-info
              id="glasses-left"
              :is-edit="isEdit"
              :values="glassesOD"
              name="glasses-left"
              eye="OD"
              type="glasses"
              v-on:changedRx="updateGlasses($event, 'od')"
            ></eye-info>

            <!-- OS Data -->
            <eye-info
              id="glasses-right"
              :is-edit="isEdit"
              :values="glassesOS"
              name="glasses-right"
              eye="OS"
              type="glasses"
              v-on:changedRx="updateGlasses($event, 'os')"
            ></eye-info>
          </div>

          <div v-if="showContactsFields" style="padding-top: 10px;">
            <div class="md-layout-item md-size-100 md-small-size-100">
              <h6>Contact Lens Information</h6>
            </div>

            <!-- OD Data -->
            <eye-info
              id="contacts-left"
              :is-edit="isEdit"
              :values="contactsOD"
              name="contacts-left"
              eye="OD"
              type="contact"
              v-on:changedRx="updateContacts($event, 'od')"
            ></eye-info>

            <!-- OS Data -->
            <eye-info
              id="contacts-right"
              :is-edit="isEdit"
              :values="contactsOS"
              name="contacts-right"
              eye="OS"
              type="contact"
              v-on:changedRx="updateContacts($event, 'os')"
            ></eye-info>
          </div>
        </div>
      </div>
    </div>

    <div class="md-layout" style="margin-top: 20px">
      <div class="md-layout-item md-size-100 md-small-size-100">
        <h6>Medical History</h6>
      </div>
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field>
          <label for="historyDiabetes">Any personal history with Diabetes ?</label>
          <md-select v-model="historyDiabetes" name="historyDiabetes">
            <md-option value="None">None</md-option>
            <md-option value="651">Juvenile Diabetes</md-option>
            <md-option value="652">Adult Onset Diabetes</md-option>
          </md-select>
        </md-field>
      </div>
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field>
          <label for="historyCancer">Any personal history with Cancer ?</label>
          <md-select v-model="historyCancer" name="historyCancer">
            <md-option value="653">None</md-option>
            <md-option value="654">Breast Cancer</md-option>
            <md-option value="655">Colon Cancer</md-option>
            <md-option value="656">Kidney Cancer</md-option>
            <md-option value="657">Brain Cancer</md-option>
            <md-option value="658">Bone Cancer</md-option>
          </md-select>
        </md-field>
      </div>
    </div>

    <div class="md-layout" style="margin-top: 20px">
      <div class="md-layout-item md-size-100 md-small-size-100">
        <h6>Personal History</h6>
      </div>
      <div class="md-layout-item md-size-100 md-small-size-100">
        <div class="checkbox-container">
          <md-checkbox v-model="personalHistory.stroke">Stroke</md-checkbox>
          <md-checkbox v-model="personalHistory.migraines">Migraines</md-checkbox>
          <md-checkbox v-model="personalHistory.heartDisease">Heart Disease</md-checkbox>
          <md-checkbox v-model="personalHistory.liverDisease">Liver Disease</md-checkbox>
          <md-checkbox v-model="personalHistory.highCholesterol">High Cholesterol</md-checkbox>
          <md-checkbox v-model="personalHistory.highBloodPressure">High Blood Pressure</md-checkbox>
        </div>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-100 md-small-size-100">
        <div class="textarea-container">
          <textarea id="personalHistory.other" v-model="personalHistory.other"
            style="width: 100%; padding: 10px 15px 10px 15px" name="personalHistory.other"
            placeholder="Other personal history . . ." resize="auto"></textarea>
        </div>
      </div>
    </div>

    <div class="md-layout" style="margin-top: 20px">
      <div class="md-layout-item md-size-100 md-small-size-100">
        <h6>Family History</h6>
      </div>
      <div class="md-layout-item md-size-100 md-small-size-100">
        <div class="checkbox-container2">
          <md-checkbox v-model="familyHistory.glaucoma">Glaucoma</md-checkbox>
          <md-checkbox v-model="familyHistory.migraines">Migraines</md-checkbox>
          <md-checkbox v-model="familyHistory.diabetes">Diabetes</md-checkbox>
          <md-checkbox v-model="familyHistory.liverDisease">Liver Disease</md-checkbox>
          <md-checkbox v-model="familyHistory.stroke">Stroke</md-checkbox>
          <md-checkbox v-model="familyHistory.highCholesterol">High Cholesterol</md-checkbox>
          <md-checkbox v-model="familyHistory.heartDisease">Heart Disease</md-checkbox>
          <md-checkbox v-model="familyHistory.cancer">Cancer</md-checkbox>
          <md-checkbox v-model="familyHistory.alzheimers">Alzheimer's</md-checkbox>
          <md-checkbox v-model="familyHistory.highBloodPressure">High Blood Pressure</md-checkbox>
          <md-checkbox v-model="familyHistory.macularDegeneration">Macular Degeneration</md-checkbox>
        </div>
      </div>
    </div>
    <div class="md-layout">
      <div class="md-layout-item md-size-100 md-small-size-100">
        <div class="textarea-container">
          <textarea id="familyHistory.other" v-model="familyHistory.other"
            style="width: 100%; padding: 10px 15px 10px 15px" name="familyHistory.other"
            placeholder="Other family history . . ." resize="auto"></textarea>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions"
import { mapGetters } from "vuex"
import EyeInfo from "./Components/EyeInfo.vue"
import EyeInfoService from "../../../../services/eye-info.service"

export default {
  components: {
    SlideYDownTransition,
    "eye-info": EyeInfo
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      eyeService: EyeInfoService,
      chiefComplaint: "",
      issues: "",
      correctiveLens: "",
      previousEyeSurgery: "",
      historyDiabetes: "",
      historyCancer: "",
      glassesOD: {
        SPH: "",
        CYL: "",
        AXS: "",
        POW: "",
        DIS: "",
        BC: "",
        DIA: "",
        COL: "",
        BRA: "",
        MAN: "",
        QT: ""
      },
      glassesOS: {
        SPH: "",
        CYL: "",
        AXS: "",
        POW: "",
        DIS: "",
        BC: "",
        DIA: "",
        COL: "",
        BRA: "",
        MAN: "",
        QT: ""
      },
      contactsOD: {
        SPH: "",
        CYL: "",
        AXS: "",
        POW: "",
        DIS: "",
        BC: "",
        DIA: "",
        COL: "",
        BRA: "",
        MAN: "",
        QT: ""
      },
      contactsOS: {
        SPH: "",
        CYL: "",
        AXS: "",
        POW: "",
        DIS: "",
        BC: "",
        DIA: "",
        COL: "",
        BRA: "",
        MAN: "",
        QT: ""
      },
      personalHistory: {
        stroke: false,
        migraines: false,
        heartDisease: false,
        liverDisease: false,
        highCholesterol: false,
        highBloodPressure: false,
        other: ""
      },
      familyHistory: {
        stroke: false,
        migraines: false,
        diabetes: false,
        cancer: false,
        glaucoma: false,
        alzheimers: false,
        heartDisease: false,
        liverDisease: false,
        highCholesterol: false,
        highBloodPressure: false,
        macularDegeneration: false,
        other: ""
      },
      touched: {},
      modelValidations: {},
      picker: null
    }
  },
  computed: {
    ...mapGetters(["ptMedical", "ptHistory", "ptFamHist", "ptPersonal"]),
    showGlassesFields() {
      return this.correctiveLens == 'I wear Glasses'
        || this.correctiveLens == 'I wear Glasses and Contacts'
        || this.correctiveLens == 'I wear a Bifocal or Progressive'
        || this.correctiveLens == 'I wear OTC readers'
        || this.correctiveLens == 'I wear Glasses and SCL'
        || this.correctiveLens == 'I wear SCL'
    },
    showContactsFields() {
      return this.correctiveLens == 'I wear Contacts'
        || this.correctiveLens == 'I wear Glasses and Contacts'
        || this.correctiveLens == 'I wear Glasses and SCL'
        || this.correctiveLens == 'I wear SCL'
    }
  },
  watch: {},
  mounted() {
    if (this.isEdit) {
      this.fillValues()
    }
  },
  methods: {
    updateGlasses($event, type) {
      const glasses = type === "od" ? this.glassesOD : this.glassesOS

      glasses.SPH = this.eyeService.removePositiveSignal($event.SPH, this.eyeService.ValidRanges.SPH.allowedWords)
      glasses.CYL = this.eyeService.removePositiveSignal($event.CYL, this.eyeService.ValidRanges.CYL.allowedWords)
      glasses.AXS = this.eyeService.removePositiveSignal($event.AXS)
      glasses.POW = this.eyeService.removePositiveSignal($event.POW)
      glasses.DIS = this.eyeService.removePositiveSignal($event.DIS)
      glasses.BC = this.eyeService.removePositiveSignal($event.BC)
      glasses.DIA = this.eyeService.removePositiveSignal($event.DIA)
      glasses.COL = $event.COL
      glasses.BRA = $event.BRA
      glasses.MAN = $event.MAN
      glasses.QT = this.eyeService.removePositiveSignal($event.QT)
    },
    updateContacts($event, type) {
      const contacts = type === "od" ? this.contactsOD : this.contactsOS
      contacts.SPH = this.eyeService.removePositiveSignal($event.SPH, this.eyeService.ValidRanges.SPH.allowedWords)
      contacts.CYL = this.eyeService.removePositiveSignal($event.CYL, this.eyeService.ValidRanges.CYL.allowedWords)
      contacts.AXS = this.eyeService.removePositiveSignal($event.AXS)
      contacts.POW = this.eyeService.removePositiveSignal($event.POW)
      contacts.DIS = this.eyeService.removePositiveSignal($event.DIS)
      contacts.BC = this.eyeService.removePositiveSignal($event.BC)
      contacts.DIA = this.eyeService.removePositiveSignal($event.DIA)
      contacts.COL = $event.COL
      contacts.BRA = $event.BRA
      contacts.MAN = $event.MAN
      contacts.QT = this.eyeService.removePositiveSignal($event.QT)
    },
    validate() {
      this.storeValues()
      return this.$validator.validateAll().then(res => {
        this.$emit("on-validated", res)
        return res
      })
    },
    verifyBoolean(value) {
      if (typeof value === "boolean") {
        return value
      }
      if (typeof value === "string") {
        return value.toLowerCase() === "true"
      }
      return false // Default case if the value is neither boolean nor string
    },
    defineEyeInfoPayload(leftEye, rightEye) {
      return {
        sphereOD: leftEye.SPH,
        cylinderOD: leftEye.CYL,
        axisOD: leftEye.AXS,
        powerOD: leftEye.POW,
        distanceOD: leftEye.DIS,
        baseCurveOD: leftEye.BC,
        diameterOD: leftEye.DIA,
        colorOD: leftEye.COL,
        sphereOS: rightEye.SPH,
        cylinderOS: rightEye.CYL,
        axisOS: rightEye.AXS,
        powerOS: rightEye.POW,
        distanceOS: rightEye.DIS,
        baseCurveOS: rightEye.BC,
        diameterOS: rightEye.DIA,
        colorOS: rightEye.COL
      }
    },
    parseEyeInfoReturn(eyeData) {
      return {
        OD: {
          SPH: eyeData.sphereOD,
          CYL: eyeData.cylinderOD,
          AXS: eyeData.axisOD,
          POW: eyeData.powerOD,
          DIS: eyeData.distanceOD,
          BC: eyeData.baseCurveOD,
          DIA: eyeData.diameterOD,
          COL: eyeData.colorOD
        },
        OS: {
          SPH: eyeData.sphereOS,
          CYL: eyeData.cylinderOS,
          AXS: eyeData.axisOS,
          POW: eyeData.powerOS,
          DIS: eyeData.distanceOS,
          BC: eyeData.baseCurveOS,
          DIA: eyeData.diameterOS,
          COL: eyeData.colorOS
        }
      }
    },
    fillValues() {
      this.chiefComplaint = this.ptMedical.chiefComplaint
      this.issues = this.ptMedical.issues
      this.correctiveLens = this.ptMedical.correctiveLens

      if (this.ptMedical.glassesHistory) {
        const parsedGlasses = this.parseEyeInfoReturn(this.ptMedical.glassesHistory)
        this.glassesOD = parsedGlasses.OD
        this.glassesOS = parsedGlasses.OS
      }

      if (this.ptMedical.contactsHistory) {
        const parsedContacts = this.parseEyeInfoReturn(this.ptMedical.contactsHistory)
        this.contactsOD = parsedContacts.OD
        this.contactsOS = parsedContacts.OS
      }

      this.previousEyeSurgery = this.ptMedical.previousEyeSurgery ? this.ptMedical.previousEyeSurgery.toString() : ""
      this.historyDiabetes =
        this.ptMedical.historyDiabetes === 0 || !this.ptMedical.historyDiabetes
          ? "None"
          : this.ptMedical.historyDiabetes.toString()
      this.historyCancer = this.ptMedical.historyCancer ? this.ptMedical.historyCancer.toString() : ""

      this.personalHistory.stroke = this.verifyBoolean(this.ptHistory.stroke)
      this.personalHistory.migraines = this.verifyBoolean(this.ptHistory.migraines)
      this.personalHistory.heartDisease = this.verifyBoolean(this.ptHistory.heartDisease)
      this.personalHistory.liverDisease = this.verifyBoolean(this.ptHistory.liverDisease)
      this.personalHistory.highCholesterol = this.verifyBoolean(this.ptHistory.highCholesterol)
      this.personalHistory.highBloodPressure = this.verifyBoolean(this.ptHistory.highBloodPressure)
      this.personalHistory.other = this.ptHistory.other || ""

      this.familyHistory.stroke = this.verifyBoolean(this.ptFamHist.stroke)
      this.familyHistory.migraines = this.verifyBoolean(this.ptFamHist.migraines)
      this.familyHistory.diabetes = this.verifyBoolean(this.ptFamHist.diabetes)
      this.familyHistory.cancer = this.verifyBoolean(this.ptFamHist.cancer)
      this.familyHistory.glaucoma = this.verifyBoolean(this.ptFamHist.glaucoma)
      this.familyHistory.alzheimers = this.verifyBoolean(this.ptFamHist.alzheimers)
      this.familyHistory.heartDisease = this.verifyBoolean(this.ptFamHist.heartDisease)
      this.familyHistory.liverDisease = this.verifyBoolean(this.ptFamHist.liverDisease)
      this.familyHistory.highCholesterol = this.verifyBoolean(this.ptFamHist.highCholesterol)
      this.familyHistory.highBloodPressure = this.verifyBoolean(this.ptFamHist.highBloodPressure)
      this.familyHistory.macularDegeneration = this.verifyBoolean(this.ptFamHist.macularDegeneration)
      this.familyHistory.other = this.ptFamHist.other || ""
    },
    storeValues() {
      this.ptMedical.chiefComplaint = this.chiefComplaint
      this.ptMedical.issues = this.issues

      this.ptMedical.correctiveLens = this.correctiveLens

      this.ptMedical.glassesHistory = this.defineEyeInfoPayload(this.glassesOD, this.glassesOS)

      this.ptMedical.contactsHistory = this.defineEyeInfoPayload(this.contactsOD, this.contactsOS)

      this.ptMedical.previousEyeSurgery = this.previousEyeSurgery
      this.ptMedical.historyDiabetes = this.historyDiabetes
      this.ptMedical.historyCancer = this.historyCancer

      this.ptHistory.stroke = this.personalHistory.stroke
      this.ptHistory.migraines = this.personalHistory.migraines
      this.ptHistory.heartDisease = this.personalHistory.heartDisease
      this.ptHistory.liverDisease = this.personalHistory.liverDisease
      this.ptHistory.highCholesterol = this.personalHistory.highCholesterol
      this.ptHistory.highBloodPressure = this.personalHistory.highBloodPressure
      this.ptHistory.other = this.personalHistory.other

      this.ptFamHist.stroke = this.familyHistory.stroke
      this.ptFamHist.migraines = this.familyHistory.migraines
      this.ptFamHist.diabetes = this.familyHistory.diabetes
      this.ptFamHist.cancer = this.familyHistory.cancer
      this.ptFamHist.glaucoma = this.familyHistory.glaucoma
      this.ptFamHist.alzheimers = this.familyHistory.alzheimers
      this.ptFamHist.heartDisease = this.familyHistory.heartDisease
      this.ptFamHist.liverDisease = this.familyHistory.liverDisease
      this.ptFamHist.highCholesterol = this.familyHistory.highCholesterol
      this.ptFamHist.highBloodPressure = this.familyHistory.highBloodPressure
      this.ptFamHist.macularDegeneration = this.familyHistory.macularDegeneration
      this.ptFamHist.other = this.familyHistory.other
    }
  }
}
</script>

<style>
:root {
  --gray: #999;
  --blue: #0074d9;
  --color: #333;
  --background-color: #fff;
  --border: 1px solid #eee;
}

.md-checkbox {
  margin: 5px 16px 5px 0;
  font-size: 0.8rem;
}

.textarea-container {
  margin-top: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.checkbox-container {
  margin-top: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 5px 0px 10px 15px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0px;
}

.field-container {
  margin-top: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px 0px 10px 0px;
}

.eye-label {
  display: flex;
  align-items: center;
  height: 100%;
  color: black;
}

.checkbox-container2 {
  margin-top: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 5px 0px 20px 15px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0px;
}

.picker {
  background-color: rgba(0, 0, 0, 0.5);
  color: #333;
  color: var(--color);
  direction: ltr;
  display: none;
  font-size: 1rem;
  line-height: 1.5;
  overflow: hidden;
  -ms-touch-action: none;
  touch-action: none;
  -webkit-transition: opacity 0.15s;
  transition: opacity 0.15s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.picker-fixed {
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1986;
  /* display: flex;
  justify-content: center;
  align-content: center; */
}

.picker-fixed>.picker-dialog {
  /* bottom: -100%;
  left: 0;
  max-height: 100%;
  position: absolute;
  right: 0;
  -webkit-transition: bottom 0.3s;
  transition: bottom 0.3s; */
  position: absolute;
  /* width: 250px; */
  height: 300px;
  /* right: 294px;  */
  /* right: 45%; */
  top: 40%;
}

.picker-fixed .picker-header {
  display: block;
  text-align: center;
}

.picker-fixed .picker-footer {
  display: table;
}

.picker-open {
  display: block;
  opacity: 0;
}

.picker-opened {
  opacity: 1;
}

.picker-opened>.picker-dialog {
  bottom: 0;
}

.picker-dialog {
  background-color: #fff;
  background-color: var(--background-color);
  border: 1px solid #eee;
  border: var(--border);
}

.picker-header {
  border-bottom: 1px solid #eee;
  border-bottom: var(--border);
  display: none;
  padding: 0.875rem 1.25rem;
  position: relative;
}

.picker-title {
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.25rem;
  margin: 0;
}

.picker-close {
  background-color: transparent;
  border-width: 0;
  color: #999;
  color: var(--gray);
  cursor: pointer;
  font-size: 1.75rem;
  height: 3rem;
  opacity: 0.75;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 3rem;
}

.picker-close:focus,
.picker-close:hover {
  opacity: 1;
  outline: none;
}

.picker-body {
  overflow: hidden;
}

.picker-grid {
  display: table;
  table-layout: fixed;
  width: 100%;
}

.picker-cell {
  display: table-cell;
  position: relative;
}

.picker-cell::before,
.picker-cell::after {
  content: "";
  display: block;
  left: 0;
  position: absolute;
  right: 0;
  z-index: 3;
}

.picker-cell::before {
  background-image: -webkit-gradient(linear, left bottom, left top, from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.05)));
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.05));
  bottom: 50%;
  margin-bottom: 1rem;
  top: 0;
}

.picker-cell::after {
  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.05)));
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.05));
  bottom: 0;
  margin-top: 1rem;
  top: 50%;
}

.picker-cell+.picker-cell {
  border-left: 1px solid #eee;
  border-left: var(--border);
}

.picker-headers .picker-cell::before {
  margin-bottom: 0;
}

.picker-headers .picker-cell::after {
  margin-top: 2rem;
}

.picker-single:not(.picker-controls):not(.picker-headers) .picker-cell::before,
.picker-single:not(.picker-controls):not(.picker-headers) .picker-cell::after {
  display: none;
}

.picker-cell__header {
  color: #999;
  color: var(--gray);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.5rem;
  margin: 0;
  overflow: hidden;
  padding: 0.25rem 0.5rem;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.picker-cell__control {
  cursor: pointer;
  height: 2rem;
  padding: 0.25rem 0.5rem;
  position: relative;
  z-index: 4;
}

.picker-cell__control::before {
  border: 0 solid #ccc;
  content: "";
  display: block;
  height: 0.5rem;
  left: 50%;
  position: absolute;
  top: 50%;
  -webkit-transform: translate(-50%, -50%) rotate(-45deg);
  -ms-transform: translate(-50%, -50%) rotate(-45deg);
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 0.5rem;
}

.picker-cell__control:hover::before {
  border-color: var(--primary);
}

.picker-cell__control--prev::before {
  border-right-width: 1px;
  border-top-width: 1px;
  margin-top: 2px;
}

.picker-cell__control--next::before {
  border-bottom-width: 1px;
  border-left-width: 1px;
  margin-bottom: 2px;
}

.picker-cell__body {
  overflow: hidden;
  position: relative;
}

.picker-cell__body::before,
.picker-cell__body::after {
  content: "";
  height: 2rem;
  left: 0;
  position: absolute;
  right: 0;
  z-index: 1;
}

.picker-cell__body::before {
  background-image: -webkit-gradient(linear,
      left bottom,
      left top,
      from(rgba(255, 255, 255, 0)),
      to(rgba(255, 255, 255, 1)));
  background-image: linear-gradient(to top, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  top: 0;
}

.picker-cell__body::after {
  background-image: -webkit-gradient(linear,
      left top,
      left bottom,
      from(rgba(255, 255, 255, 0)),
      to(rgba(255, 255, 255, 1)));
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  bottom: 0;
}

.picker-single .picker-cell__body::before,
.picker-single .picker-cell__body::after {
  display: none;
}

.picker-list {
  list-style: none;
  margin: -2rem 0;
  padding: 0;
  position: relative;
}

.picker-item {
  color: #999;
  color: var(--gray);
  padding: 0.25rem 0.5rem;
  text-align: center;
  white-space: nowrap;
}

.picker-picked {
  color: #0074d9;
  color: var(--blue);
  font-size: 1.125em;
  line-height: 1.5rem;
}

.picker-footer {
  border-top: 1px solid #eee;
  border-top: var(--border);
  display: none;
  width: 100%;
}

.picker-cancel,
.picker-confirm {
  background-color: transparent;
  border-width: 0;
  cursor: pointer;
  display: table-cell;
  font-size: 1rem;
  padding: 0.75rem 1rem;
  width: 50%;
}

.picker-cancel:focus,
.picker-cancel:hover,
.picker-confirm:focus,
.picker-confirm:hover {
  background-color: #fcfcfc;
  outline: none;
}

.picker-confirm {
  color: #0074d9;
  color: var(--blue);
}
</style>
